<template>
  <master-main
    :route="getModuleRoute"
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :tableProperties="tableProperties"
    :exportProperties="{
      pdf: {
        filename: `${$t('sowing.seedbeds')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('sowing.seedbeds')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    @refresh="refresh"
  ></master-main>
</template>
<script>
import SeedbedTable from './seedbeds-table';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '50%' },
    };
  },
  computed: {
    getModuleRoute() {
      return 'seeding/seedbeds';
    },
    buildTableProperties() {
      return {
        tableColumns: [...SeedbedTable().tableColumns],
        effectTags: 'dark',
        model: 'supplier',
        widthOperations: 110,
        widthColumnStatus: 160,
      };
    },
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
};
</script>
